import {Vue} from "ui.vue";

export default {
	name: "Banner",
	props: {
		file: {
			type: [Object, false],
			default: () => {
				return false;
			}
		},
		isVideo: {
			type: Boolean,
			default: false,
		},
		link: {
			type: String,
			default: "",
		},
		bannerClass: {
			type: String,
			default: ""
		},
		linkClass: {
			type: String,
			default: ""
		},
		posterImg: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			iOS: /iPhone|iPad|iPod/i.test(window.navigator.userAgent)
		};
	},
	template: '<div>' +
		'		 <a v-if="link" :href="link" target="_blank" :class="bannerClass">' +
		'			<video v-if="isVideo" :loop="!iOS" :autoplay="!iOS" :poster="iOS ? posterImg : ``" playsinline muted :class="bannerClass"><source :src="file.SRC" :type="file.CONTENT_TYPE"></video>' +
		'			<img v-else :class="bannerClass" :src="file.SRC" />' +
		'		</a>' +
		'		<div v-else :class="linkClass">' +
		'			<video v-if="isVideo" :loop="!iOS" :autoplay="!iOS" :poster="iOS ? posterImg : ``" playsinline muted :class="bannerClass"><source :src="file.SRC" :type="file.CONTENT_TYPE"></video>' +
		'			<img v-else :class="bannerClass" :src="file.SRC" />' +
		'		</div>' +
		'	</div>',
};
